export const addToBoard = "Lyc";
export default {addToBoard};